export const endeavorMetadataUnpack = ({
    endeavorMetadata,
    endeavorVideo,
    key,
}) => {
    if (!endeavorMetadata) {
        return { isEmpty: true };
    }
    return {
        isEmpty: false,
        key,
        accessLevel: endeavorMetadata.metadata.accessLevel,
        thumbnailSrc: endeavorMetadata.metadata.thumbnailUrl,
        posterSrc: endeavorMetadata.metadata.posterUrl,
        dashUrl: endeavorVideo ? endeavorVideo.dashUrl : undefined,
        hlsUrl: endeavorVideo ? endeavorVideo.hlsUrl : undefined,
        title: endeavorMetadata.metadata.title,
        description: endeavorMetadata.metadata.description,
    };
};
